Backbone = require 'backbone'

# NotificationModel
# expected properties
module.exports = class NotificationModel extends Backbone.Model



// WEBPACK FOOTER //
// ./app/models/notification.coffee